<template>
  <VueCustomTooltip :label="text" position="is-bottom" :multiline="true">
    <svg fill="#dbbfa7" height="30px" width="30px" enable-background="new 0 0 512 512" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
      <path
          d="m256 0c-141.17 0-256 114.83-256 256s114.83 256 256 256 256-114.83 256-256-114.83-256-256-256zm-10.667 426.67c-17.646 0-32-14.354-32-32s14.354-32 32-32 32 14.354 32 32-14.354 32-32 32zm32-130.12v34.125c0 5.896-4.771 10.667-10.667 10.667h-42.666c-5.896 0-10.667-4.771-10.667-10.667v-53.333c0-23.521 19.146-42.667 42.667-42.667s42.667-19.146 42.667-42.667-19.146-42.667-42.667-42.667-42.667 19.146-42.667 42.667v10.667c0 5.896-4.771 10.667-10.667 10.667h-42.666c-5.896 0-10.667-4.771-10.667-10.667v-10.667c0-58.813 47.854-106.67 106.67-106.67s106.67 47.855 106.67 106.67c0 51.188-36.063 94.563-85.334 104.54z"/>
    </svg>
  </VueCustomTooltip>
</template>

<script>
export default {
  name: "AppTooltip",
  props: {
    text: String
  }
}
</script>

<style scoped>
svg:hover {
  transition: .3s;
  fill: #B9765B;
}
</style>
<style>
@media(max-width: 600px) {
  .vue-custom-tooltip.is-bottom.has-multiline.is-medium:after{
    width: 125px!important;
  }
}
</style>